/**
 * Repository for obtaining Entities by their ID or as a list
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

import { shuffle } from "../util.js"

export class Repository {

    constructor() {
        this.map = {};
		this.list = [];
		this.shuffled = false;
    }
	
	register(work) {
		this.map [work.getID()] = work;
		this.list.push(work);
	}
	
	getByID(id) {
		return this.map [id];
	}
	
	getList(filter) {
		if (this.shuffled == false) {
			shuffle(this.list);
			this.shuffled = true;
		}		

		if (typeof filter === "undefined") {
			return this.list;
		} else {
			return this.list.filter(filter);
		}
	}
	
}